import { Component } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { loginModel } from 'src/app/Interface/login';
import { ApiRequestsService } from 'src/app/services/api-requests.service';
import { AuthService } from 'src/app/services/auth.service';
import { CommonFunctionService } from 'src/app/services/common-function.service';
import { DataManipulateService } from 'src/app/services/data-manipulate.service';
import { WebsocketService } from 'src/app/services/websocket.service';

@Component({
  selector: 'app-login-page',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.scss'],
})
export class LoginPageComponent {
  public model: loginModel = { employeeid: '', password: '' };
  showPassword: boolean = false;
  errorEmployeeid: string = '';
  errorPassword: string = '';
  errorMsg: string = ''
  inputType: string = 'password';
  showLoader:boolean = false;


  constructor(
    private apiRequests: ApiRequestsService,
    private route: Router, private authService: AuthService, private toster: ToastrService, private data: DataManipulateService, private commonFunction:CommonFunctionService, private websocket:WebsocketService
  ) { }


  login(form: NgForm) {
  
    this.errorEmployeeid = '';
    this.errorPassword = '';
    this.errorMsg = '';
    // Check Form Validity
    if (form.invalid) {
      Object.values(form.controls).forEach(control => control.markAsTouched());
      return;
    }
    if (!window.navigator.onLine) {
      this.toster.error('No Internet Connection');
    } else
     if (!this.model.employeeid && !this.model.password) {
      this.errorMsg = 'Please Enter LoginId and Password';
    } else if (!this.model.employeeid) {
      this.errorEmployeeid = 'Please enter Login Id';
    } else if (!this.model.password) {
      this.errorPassword = 'Please enter password';
    } else {
      this.showLoader = true;

      this.apiRequests.postApiCall("users/Login", {criteria:{loginid: this.model.employeeid, pwd: this.model.password}}).subscribe(res=> {
      this.showLoader = false;

        if (res['errorCode'] == this.apiRequests.NO_ERROR) {
          this.apiRequests.updateOrSetTokenValue(res['Data']['ntk']);
          this.commonFunction.userId = this.model.employeeid;
          this.commonFunction.userName = this.model.employeeid; 
          this.data.userName=res['Data']['username'];
          this.commonFunction.servivngLocationId = res.Data.servingLocID
          this.websocket.createWebSocketConnection();        
          this.route.navigateByUrl("/process-physical-ITR");
        } else {
          this.toster.error(res['errorDescription']);
        }

      })

    }

  }
  passwordVisiblity() {
    this.showPassword = !this.showPassword;
    if (this.showPassword) {
      this.inputType = 'text'
    } else {
      this.inputType = 'password'
    }

  }

  // login() {

  //   this.apiRequests.postApiCall( "user/loginAuthenticate",this.model).subscribe((res: any,) => {
  //     if (res.errorCode == this.apiRequests.NO_ERROR) {
  //       this.apiRequests.Token = res.Data.ntk;
  //       this.apiRequests.postApiCall("user/login", this.model).subscribe((data: RESPONSE) => {

  //         if (data.errorCode == this.apiRequests.NO_ERROR) {
  //           this.apiRequests._syncUser(data.Data);
  //           this.route.navigateByUrl("/dashboard");
  //         }
  //       }).unsubscribe()
  //     }
  //   }).unsubscribe()
  // }
}
